export default __webpack_public_path__ + "static/media/nutrition1.81ce15ab.png";